export default __webpack_public_path__ + "static/media/payments-terminal-image.173cdf29.png";